module.exports = __webpack_public_path__ + "img/157.9ebe006e.jpg";